import { render, staticRenderFns } from "./assistant-wig-card.vue?vue&type=template&id=08067b64&scoped=true"
import script from "./assistant-wig-card.vue?vue&type=script&lang=js"
export * from "./assistant-wig-card.vue?vue&type=script&lang=js"
import style0 from "./assistant-wig-card.vue?vue&type=style&index=0&id=08067b64&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08067b64",
  null
  
)

export default component.exports